<template>
  <div>
    <Table border :columns="columns1" :data="data1" :span-method="handleSpan">
      <template slot-scope="{ row, index }" slot="action1">
        <!-- <Button type="warning" size="small" icon="md-remove" @click="deleteKPIAll(row,index)" :disabled="applyEditFlag=='1'&& targetRevisionState" style="margin-left:15px"></Button> -->
        <Button
          type="warning"
          size="small"
          icon="md-trash"
          @click="deleteKPIAll(row, index)"
          v-if="targetRevisionState"
          :disabled="applyEditFlag == '1'"
        ></Button>
        <Button
          type="warning"
          size="small"
          icon="md-trash"
          @click="deleteKPIAll(row, index)"
          v-else
          :disabled="row.id ? true : false"
        ></Button>
      </template>
      <template slot-scope="{ row, index }" slot="achKeyNote">
        <Input
          type="textarea"
          v-model="row.achKeyNote"
          v-if="$store.getters.inputShowData"
          :disabled="
            (tabName != 'goalSetting' || applyEditFlag == '1') &&
              targetRevisionState
          "
          :autosize="true"
          @on-change="targetItemChange(row, index, 'achKeyNote')"
        />
        <span class="textareaHid" v-else>{{ row.achKeyNote }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="weight">
        <Input
          type="number"
          v-model="row.weight"
          v-if="$store.getters.inputShowData"
          :disabled="
            (tabName != 'goalSetting' || applyEditFlag == '1') &&
              targetRevisionState
          "
          :autosize="true"
          @on-change="targetItemChange(row, index, 'weight')"
        />
        <span class="textareaHid" v-else>{{ row.weight }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="details" style="width:100%">
        <Input
          type="textarea"
          v-model="row.details"
          v-if="$store.getters.inputShowData"
          :disabled="
            (tabName != 'goalSetting' || applyEditFlag == '1') &&
              targetRevisionState
          "
          :autosize="true"
          @on-change="targetItemChange(row, index, 'details')"
        />
        <span class="textareaHid" v-else>{{ row.details }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="startDate">
        <DatePicker
          type="date"
          v-model="row.startDate"
          :editable="false"
          v-if="$store.getters.inputShowData"
          :disabled="
            (tabName != 'goalSetting' || applyEditFlag == '1') &&
              targetRevisionState
          "
          :transfer="true"
          :clearable="false"
          @on-change="targetItemChange(row, index, 'startDate')"
        />
        <span class="textareaHid" v-else>{{
          date.dateVal(row.startDate, "YYYY-MM-DD")
        }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="endDate">
        <DatePicker
          type="date"
          v-model="row.endDate"
          :editable="false"
          v-if="$store.getters.inputShowData"
          :disabled="
            (tabName != 'goalSetting' || applyEditFlag == '1') &&
              targetRevisionState
          "
          :transfer="true"
          :clearable="false"
          @on-change="targetItemChange(row, index, 'endDate')"
        />
        <span class="textareaHid" v-else>{{
          date.dateVal(row.endDate, "YYYY-MM-DD")
        }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="measure">
        <Input
          type="textarea"
          v-model="row.measure"
          v-if="$store.getters.inputShowData"
          :disabled="
            (tabName != 'goalSetting' || applyEditFlag == '1') &&
              targetRevisionState
          "
          :autosize="true"
          @on-change="targetItemChange(row, index, 'measure')"
        />
        <span class="textareaHid" v-else>{{ row.measure }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="empDetails">
        <Input
          type="textarea"
          v-model="row.empDetails"
          v-if="$store.getters.inputShowData"
          :autosize="true"
          :disabled="applyEditFlag == '1' || userDeptFlag != '1'"
          @on-change="targetItemChange(row, index, 'empDetails')"
        />
        <span class="textareaHid" v-else>{{ row.empDetails }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="indirSupFeedback">
        <Input
          type="textarea"
          v-model="row.indirSupFeedback"
          :autosize="true"
          :disabled="
            applyEditFlag == '1' || (userDeptFlag != '3' && userDeptFlag != '4')
          "
          @on-change="targetItemChange(row, index, 'indirSupFeedback')"
        />
      </template>
      <template slot-scope="{ row, index }" slot="dirSupFeedback">
        <Input
          type="textarea"
          v-model="row.dirSupFeedback"
          v-if="$store.getters.inputShowData"
          :autosize="true"
          :disabled="
            applyEditFlag == '1' || (userDeptFlag != '2' && userDeptFlag != '4')
          "
          @on-change="targetItemChange(row, index, 'dirSupFeedback')"
        />
        <span class="textareaHid" v-else>{{ row.dirSupFeedback }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="finish">
        <Input
          type="textarea"
          v-model="row.finish"
          v-if="$store.getters.inputShowData"
          :autosize="true"
          :disabled="applyEditFlag == '1' || userDeptFlag != '1'"
          @on-change="targetItemChange(row, index, 'finish')"
        />
        <span class="textareaHid" v-else>{{ row.finish }}</span>
      </template>
      <template slot-scope="{ row }" slot="status">
        <span style="color:red" v-if="row.status == '新增'"
          ><!-- 新增 -->{{ $t("Add") }}</span
        >
        <span style="color:red" v-if="row.status == '删除'"
          ><!-- 删除 -->{{ $t("Delete") }}</span
        >
        <span style="color:red" v-if="row.status == '编辑'"
          ><!-- 编辑 -->{{ $t("Edit") }}</span
        >
      </template>
      <!-- <template slot-scope="{ row,index }" slot="empDetails">
                <Input type="textarea" v-model="row.empDetails" :autosize="true" :disabled="applyEditFlag=='1'" @on-change="targetItemChange(row,index,'empDetails')"/>
            </template> -->
      <template slot-scope="{ row, index }" slot="action12">
        <!-- <Button type="success" size="small" @click="editKPI(row,index)">新增</Button> -->

        <Button
          type="success"
          size="small"
          icon="md-add"
          @click="editKPI(row, index)"
          :disabled="applyEditFlag == '1' && targetRevisionState"
        ></Button>
        <Button
          :disabled="
            !row.deleteState ||
              data1.filter(item => item.commonId == row.commonId).length == 1
          "
          type="warning"
          style="margin-left:15px"
          size="small"
          icon="md-remove"
          @click="deleteKPI12(row, index)"
        ></Button>
      </template>
    </Table>
    <div
      style="display: flex; justify-content:flex-end; margin-top:10px"
      v-if="tabName == 'goalSetting'"
    >
      <Button
        style="margin-right:15px"
        @click="exportModal"
        type="primary"
        v-if="applyEditFlag != '1' && userDeptFlag == '1'"
      >
        {{ $t("PB_Export") }}</Button
      >
      <Upload
        action="/api/resource/upload"
        :before-upload="onExcelInport"
        style="margin-right:15px"
        v-if="applyEditFlag != '1' && userDeptFlag == '1'"
      >
        <Button
          type="primary"
          v-if="applyEditFlag != '1' && userDeptFlag == '1'"
        >
          {{ $t("import_Ach") }}
        </Button>
      </Upload>
      <Button
        style="margin-right:15px"
        @click="selectPlan"
        :disabled="applyEditFlag == '1'"
        >{{ $t("Select_Target") }}</Button
      >
      <Button
        @click="addKPI()"
        :disabled="applyEditFlag == '1' && targetRevisionState"
        ><!-- 新增 -->{{ $t("Add") }}</Button
      >
    </div>

    <Modal v-model="modalShow" :title="$t('Ach_PermaceSelct')" width="80%">
      <Table
        border
        ref="selection"
        :columns="columnsModal"
        :loading="columnsLoading"
        :data="dataModal"
        @on-selection-change="itemClick"
      ></Table>
      <div slot="footer">
        <Button @click="modalSave"><!-- 确认 -->{{ $t("Confirm") }}</Button>
        <Button @click="modalShow = false"
          ><!-- 取消 -->{{ $t("Cancel") }}</Button
        >
      </div>
    </Modal>
    <Modal
      v-model="exportModalValue"
      :title="$t('Ach_PermaceSelct')"
      width="80%"
      footer-hide
      ><Table
        border
        :columns="columns2"
        :data="data2"
        :span-method="handleSpan2"
      >
      </Table>
      <div
        style="    display: flex;
    flex-direction: row-reverse;margin-top: 15px"
      >
        <Button
          @click="importDataConfirm"
          type="primary"
          :disabled="data2.length == 0"
          >{{ $t("Confirm") }}</Button
        >
        <Button @click="exportModalValue = false" style="margin-right: 15px">{{
          $t("Cancel")
        }}</Button>
      </div>
    </Modal>
    <Modal v-model="errorTableModalValue" title="错误信息" width="600">
      <Table :columns="errorTableColunms" :data="errorTableData" border></Table>
    </Modal>
  </div>
</template>

<script>
import columns from "./columns.js";
import DateUtil from "@/util/DateUtil";
import axios from "axios";
export default {
  props: ["tabName"],
  data() {
    return {
      date: new DateUtil(),
      status: "",
      applyEditFlag: "",
      userDeptFlag: "",
      exportModalValue: false,
      // KPI 指标
      columns1: [],
      errorTableData: [],
      data1: [],
      data2: [],
      errorTableModalValue: false,
      kpiIdNum: 0,
      spanb: [],
      spanb2: [],
      modalShow: false,
      columnsLoading: false,
      dataModal: [],
      targetIdList: [],
      targetRevisionState: true,
      oldData: [],
      editableFlag:false
    };
  },
  computed: {
    errorTableColunms() {
      return [
        {
          type: "index",
          width: 100,
          align: "center"
        },
        {
          title: "错误信息" /* 错误信息 */,
          key: "errorMessage"
        }
      ];
    },
    columnsModal() {
      return [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: this.$t("Performance_Priorities") /* 绩效重点 */,
          key: "achKeyNote"
        },
        {
          title: this.$t("Share_Name") /* 分享人 */,
          key: "sharerName"
        },
        {
          title: this.$t("Share_Date") /* 分享时间 */,
          key: "createTime",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.createTime, "YYYY-MM-DD HH:mm")
            );
          }
        }
      ];
    },
    goalPersonalGoalsColumns: function() {
      return [
        {
          title: this.$t("Delete"),
          slot: "action1",
          align: "center",
          minWidth: 70
        },
        {
          title: /* "绩效重点" */ this.$t("Performance_Priorities"),
          slot: "achKeyNote",
          minWidth: 200,
          align: "center",
          ellipsis: true
        },
        {
          title: /* "权重" */ this.$t("Weight"),
          slot: "weight",
          minWidth: 160,
          align: "center",
          ellipsis: true
        },
        {
          title: /* "详细描述" */ this.$t("Detailed_Description"),
          slot: "details",
          align: "center",
          minWidth: 300
          // ellipsis:true
        },
        {
          title: /* "开始日期" */ this.$t("Start_Date"),
          slot: "startDate",
          align: "center",
          minWidth: 160
        },
        {
          title: /* "结束日期" */ this.$t("End_Date"),
          slot: "endDate",
          align: "center",
          minWidth: 160
        },
        {
          title: /* "衡量指标" */ this.$t("Detailed_Measures"),
          slot: "measure",
          align: "center",
          minWidth: 320
          // ellipsis:true
        },
        {
          title: /* "删除" */ this.$t("Action"),
          slot: "action12",
          align: "center",
          minWidth: 120
        }
      ];
    },
    midPersonalGoalsColumns: function() {
      return [
        {
          title: /* "绩效重点" */ this.$t("Performance_Priorities"),
          slot: "achKeyNote",
          align: "center",
          minWidth: 120,
          ellipsis: true
        },
        {
          title: /* "权重" */ this.$t("Weight"),
          slot: "weight",
          minWidth: 160,
          align: "center",
          ellipsis: true
        },
        {
          title: /* "详细描述" */ this.$t("Detailed_Description"),
          slot: "details",
          align: "center",
          minWidth: 300
        },
        {
          title: /* "衡量指标" */ this.$t("Detailed_Measures"),
          slot: "measure",
          align: "center",
          minWidth: 300
          // ellipsis:true
        },
        {
          title: this.$t("longText33") /* 进度说明及后期回顾(员工填写) */,
          slot: "empDetails",
          align: "center",
          minWidth: 200
          // ellipsis:true
        },
        {
          title: this.$t("Dotted-Line_Manager_Feedback") /* 虚线上级反馈 */,
          slot: "indirSupFeedback",
          align: "center",
          minWidth: 150,
          maxWidth: 150
          // ellipsis:true
        },
        {
          title: this.$t("Line_Manager_Feedback") /* 直线上级反馈 */,
          slot: "dirSupFeedback",
          align: "center",
          minWidth: 225,
          maxWidth: 225
          // ellipsis:true
        }
      ];
    },
    yearPersonalGoalsColumns: function() {
      return [
        {
          title: /* "绩效重点" */ this.$t("Performance_Priorities"),
          slot: "achKeyNote",
          align: "center",
          minWidth: 120,
          ellipsis: true
        },
        {
          title: /* "权重" */ this.$t("Weight"),
          slot: "weight",
          minWidth: 160,
          align: "center",
          ellipsis: true
        },
        {
          title: /* "详细描述" */ this.$t("Detailed_Description"),
          slot: "details",
          align: "center",
          minWidth: 300
          // ellipsis:true
        },
        {
          title: /* "衡量指标" */ this.$t("Detailed_Measures"),
          slot: "measure",
          align: "center",
          minWidth: 300
          // ellipsis:true
        },
        // {
        //     title: /* "实际完成情况" */this.$t('Completion_Status'),
        //     slot: "finish",
        //     align: "center",
        //     minWidth: 200,
        //     ellipsis:true
        // },
        {
          title: /* "员工说明" */ this.$t("Employee_Comment"),
          slot: "empDetails",
          align: "center",
          minWidth: 300
          // ellipsis:true
        },
        {
          title: this.$t("Dotted-Line_Manager_Feedback") /* 虚线上级反馈 */,
          slot: "indirSupFeedback",
          align: "center",
          minWidth: 150,
          maxWidth: 150,
          // ellipsis:true,
          hidden: true
        },
        {
          title: this.$t("Line_Manager_Feedback") /* 直线上级反馈 */,
          slot: "dirSupFeedback",
          align: "center",
          minWidth: 225,
          maxWidth: 225,
          // ellipsis:true,
          hidden: true
        }
      ];
    },
    columns2() {
      return [
        {
          title: /*"合并序号"*/ this.$t("commonId"),
          key: "commonId",
          minWidth: 120,
          align: "center"
        },
        {
          title: this.$t("Performance_Priorities") /* 绩效重点 */,
          key: "achKeyNote",
          minWidth: 180,
          align: "center"
        },
        {
          title: /* "权重" */ this.$t("Weight"),
          key: "weight",
          minWidth: 120,
          align: "center"
        },
        {
          title: /* "详细描述" */ this.$t("Detailed_Description"),
          key: "details",
          minWidth: 260,
          align: "center"
        },
        {
          title: /* "开始日期" */ this.$t("Start_Date"),
          key: "startDate",
          minWidth: 180,
          align: "center"
        },
        {
          title: /* "结束日期" */ this.$t("End_Date"),
          key: "endDate",
          minWidth: 180,
          align: "center"
        },
        {
          title: /* "衡量指标" */ this.$t("Detailed_Measures"),
          key: "measure",
          minWidth: 260,
          align: "center"
        }
      ];
    }
  },
  watch: {
    targetRevisionState(newVal, oldVal) {
      this.targetRevisionState = newVal;
    },
    "$i18n.locale"(newValue) {
      if (this.tabName == "midTermReview") {
        this.getMidData();
        // this.columns1=this.midPersonalGoalsColumns
      } else if (this.tabName == "yearEndSummary") {
        this.getMidData();
        // this.columns1=this.yearPersonalGoalsColumns
      } else {
        this.columns1 = this.goalPersonalGoalsColumns;
        this.$emit("onInter");
      }
    }
  },
  created() {
    if (this.tabName == "midTermReview") {
      this.getMidData();
      this.columns1 = this.midPersonalGoalsColumns;
    } else if (this.tabName == "yearEndSummary") {
      this.getMidData();
      this.columns1 = this.yearPersonalGoalsColumns;
    } else {
      this.columns1 = this.goalPersonalGoalsColumns;
    }
  },
  methods: {
    importDataConfirm() {
      this.$Modal.confirm({
        title: this.$t("confirmAction"),
        onOk: () => {
          this.data2.forEach(item => {
            item.commonId = Number(item.commonId) - 1;
          });
          this.data1 = JSON.parse(JSON.stringify(this.data2));
          this.tableSpan();
          this.data2 = [];
          this.exportModalValue = false;
          this.$Message.success(this.$t("actionSuccess"));
        }
      });
    },
    // 导入
    onExcelInport(file) {
      this.$importExcelActive(file, this.columns2, data => {
        // 第一天改版后 是列名
        data.splice(0, 1);
        data = data.filter(item => item.commonId);
        console.log(data);
        // 检验 是否重复 commonId 不能出现1 2 1
        let flag = true;
        this.errorTableData = [];
        let checkIdArr = [];
        let errorTable = [];
        let arrData = data;
        if (arrData.length > 0) {
          arrData.map((item, index) => {
            //包含 且 上一个id不和当前的id不相同 并且 绩效重点 权重 详细描述 开始日期 结束日期 不同 都报错
            if (checkIdArr.includes(item.commonId)) {
              if (arrData[index - 1].commonId != item.commonId) {
                errorTable.push({
                  errorMessage:
                    "第" + (index + 3) + "行" + this.$t("checkErrorMessage")
                });
                flag = false;
              }
              if (arrData[index - 1].achKeyNote != item.achKeyNote) {
                errorTable.push({
                  errorMessage:
                    "第" + (index + 3) + "行" + "存在相同合并序号不同绩效重点"
                });
                flag = false;
              }
              if (arrData[index - 1].weight != item.weight) {
                errorTable.push({
                  errorMessage:
                    "第" + (index + 3) + "行" + "存在相同合并序号不同权重"
                });
                flag = false;
              }
              if (arrData[index - 1].details != item.details) {
                errorTable.push({
                  errorMessage:
                    "第" + (index + 3) + "行" + "存在相同合并序号不同详细描述"
                });
                flag = false;
              }
              if (arrData[index - 1].startDate != item.startDate) {
                errorTable.push({
                  errorMessage:
                    "第" + (index + 3) + "行" + "存在相同合并序号不同开始时间"
                });
                flag = false;
              }
              if (arrData[index - 1].endDate != item.endDate) {
                errorTable.push({
                  errorMessage:
                    "第" + (index + 3) + "行" + "存在相同合并序号不同结束时间"
                });
                flag = false;
              }
            } else {
              if (!checkIdArr.includes(item.commonId)) {
                checkIdArr.push(item.commonId);
              }
            }
          });
          // 校验通过
          if (flag) {
            arrData.forEach(item => {
              item.commonId = Number(item.commonId);
              item.deleteState = true;
              let wei = "";
              if (item.weight != undefined || item.weight) {
                wei = item.weight.toString();
              } else {
                wei = item.weight;
              }
              if (wei != undefined && wei.includes(".")) {
                // let reg=new RegExp('%','')

                // let str=wei.replace(reg,"")
                // item.weight=str
                item.weight = Number(wei) * 100;
              }
            });
            this.data2 = arrData;
            this.tableSpan2();
            this.exportModalValue = true;
          } else {
            // 存在错误信息 打开表格
            this.errorTableData = errorTable;
            this.errorTableModalValue = true;
            return false;
          }
        } else {
          this.$Message.error(this.$t("pleaseFillData"));
        }
      });
      return false;
    },
    exportModal() {
      let nowDate = this.date.dateVal(new Date(), "YYYY-MM-DD HH-mm-ss");
      nowDate = nowDate.replace("-", "");
      nowDate = nowDate.replace("-", "");
      nowDate = nowDate.replace(" ", "");
      nowDate = nowDate.replace("-", "");
      nowDate = nowDate.replace("-", "");
      let arrData = JSON.parse(JSON.stringify(this.data1));
      arrData.forEach(item => {
        item.commonId = Number(item.commonId) + 1;
        item.startDate = item.startDate
          ? this.date.dateVal(item.startDate, "YYYY-MM-DD")
          : "";
        item.endDate = item.endDate
          ? this.date.dateVal(item.endDate, "YYYY-MM-DD")
          : "";
      });

      this.$exportExcelActive(
        this.columns2,
        "目标设定绩效重点" + nowDate,
        arrData,
        [],
        this.$t(this.$t("excelRemind"))
      );
    },
    getMidData() {
      if (this.tabName == "yearEndSummary") {
        if (this.userDeptFlag == "1") {
          if (this.status < 5) {
            this.columns1 = this.yearPersonalGoalsColumns.filter(function(e) {
              return !e.hidden;
            });
          } else {
            this.columns1 = this.yearPersonalGoalsColumns;
          }
        } else {
          this.columns1 = this.yearPersonalGoalsColumns;
        }
      } else if (this.tabName == "midTermReview") {
        this.columns1 = this.midPersonalGoalsColumns;
      } else {
        this.columns1 = this.goalPersonalGoalsColumns;
      }
      this.tableSpan();
    },
    // editKPI(row,index) {
    //     this.$set(this.data1[index],'deleteState',true)
    //     this.$set(this.oldData[index],'deleteState',true)
    //     let array=[]
    //     this.data1.forEach(res => {
    //         if(res.commonId==row.commonId){
    //             array.push(res)
    //         }
    //     })
    //     const ids = array.map(value=>Number(value.commonId));
    //     const idsSet =  new Set(ids);
    //     if(idsSet.size == ids.length){
    //         this.data1.splice(index+1,0,{commonId:Number(row.commonId),achKeyNote:row.achKeyNote,weight:row.weight,details:row.details,startDate:row.startDate,endDate:row.endDate,measure:'',deleteState:true,status:'新增'})
    //         this.oldData.splice(index+1,0,{commonId:Number(row.commonId),achKeyNote:row.achKeyNote,weight:row.weight,details:row.details,startDate:row.startDate,endDate:row.endDate,measure:'',deleteState:true,status:'新增'})
    //         this.tableSpan()
    //     }else {
    //         this.data1.splice(index+(ids.length),0,{commonId:Number(row.commonId),achKeyNote:row.achKeyNote,weight:row.weight,details:row.details,startDate:row.startDate,endDate:row.endDate,measure:'',deleteState:true,status:'新增'})
    //         this.oldData.splice(index+(ids.length),0,{commonId:Number(row.commonId),achKeyNote:row.achKeyNote,weight:row.weight,details:row.details,startDate:row.startDate,endDate:row.endDate,measure:'',deleteState:true,status:'新增'})
    //         this.tableSpan()
    //     }

    // },
    editKPI(row, index) {
      // if (!this.targetRevisionState) {
      //       this.$set(this.oldData[index], "deleteState", true);
      // }
      this.$set(this.data1[index], "deleteState", true);
      this.data1.splice(index + 1, 0, {
        commonId: Number(row.commonId),
        achKeyNote: row.achKeyNote,
        weight: row.weight,
        details: row.details,
        startDate: row.startDate,
        endDate: row.endDate,
        measure: "",
        deleteState: true,
        status: "新增"
      });
      this.oldData.splice(index + 1, 0, {
        commonId: Number(row.commonId),
        achKeyNote: row.achKeyNote,
        weight: row.weight,
        details: row.details,
        startDate: row.startDate,
        endDate: row.endDate,
        measure: "",
        deleteState: true,
        status: "新增"
      });
      this.tableSpan();
    },
    deleteKPI12(row, index) {
      if (row.status == "删除") {
        return;
      }
      this.$Modal.confirm({
        title: this.$t("Are_you_sure_to_delete"),
        onOk: () => {
          if (
            !this.targetRevisionState &&
            (row.status == "" || row.status == "编辑")
          ) {
            row.status = "删除";
            this.$set(this.data1[index], "status", "删除");
          } else {
            this.data1.splice(index, 1);
            this.oldData.splice(index, 1);
            this.tableSpan();
            let array = [];
            this.data1.forEach(res => {
              if (res.commonId == row.commonId) {
                array.push(res);
              }
            });
            const ids = array.map(value => value.commonId);
            const idsSet = new Set(ids);
            if (idsSet.size == ids.length) {
              this.data1.forEach((res, index) => {
                if (res.commonId == row.commonId) {
                  this.$set(this.data1[index], "deleteState", false);
                  this.$set(this.oldData[index], "deleteState", false);
                }
              });
            }
          }
        }
      });
    },
    deleteKPIAll(row, index) {
      this.$Modal.confirm({
        title: this.$t("Delete_Performance"),
        onOk: () => {
          var newArray = this.data1.filter(val => {
            return val.commonId != row.commonId;
          });
          var newArray1 = this.oldData.filter(val => {
            return val.commonId != row.commonId;
          });
          this.data1 = newArray;
          this.oldData = newArray1;
          this.tableSpan();
        }
      });
    },
    addKPI() {
      if (!this.targetRevisionState) {
        this.data1.push({
          achKeyNote: "",
          weight: "",
          details: "",
          startDate: this.date.dateVal(new Date(), "YYYY") + "-01-01",
          endDate: this.date.dateVal(new Date(), "YYYY") + "-12-31",
          measure: "",
          commonId: this.kpiIdNum++,
          deleteState: false,
          status: "新增"
        });
        this.oldData.push({
          achKeyNote: "",
          weight: "",
          details: "",
          startDate: this.date.dateVal(new Date(), "YYYY") + "-01-01",
          endDate: this.date.dateVal(new Date(), "YYYY") + "-12-31",
          measure: "",
          commonId: this.kpiIdNum++,
          deleteState: false,
          status: "新增"
        });
      } else {
        this.data1.push({
          achKeyNote: "",
          weight: "",
          details: "",
          startDate: this.date.dateVal(new Date(), "YYYY") + "-01-01",
          endDate: this.date.dateVal(new Date(), "YYYY") + "-12-31",
          measure: "",
          commonId: this.kpiIdNum++,
          deleteState: false
        });
        this.oldData.push({
          achKeyNote: "",
          weight: "",
          details: "",
          startDate: this.date.dateVal(new Date(), "YYYY") + "-01-01",
          endDate: this.date.dateVal(new Date(), "YYYY") + "-12-31",
          measure: "",
          commonId: this.kpiIdNum++,
          deleteState: false
        });
      }
      this.tableSpan();
    },
    targetItemChange(row, i, key) {
      this.data1.forEach((res, index) => {
        if (res.commonId == row.commonId) {
          key == "achKeyNote"
            ? this.$set(this.data1[index], "achKeyNote", row.achKeyNote)
            : "";
          key == "weight"
            ? this.$set(this.data1[index], "weight", row.weight)
            : "";
          key == "details"
            ? this.$set(this.data1[index], "details", row.details)
            : "";
          key == "startDate"
            ? this.$set(
                this.data1[index],
                "startDate",
                this.date.dateVal(row.startDate, "YYYY-MM-DD")
              )
            : "";
          key == "endDate"
            ? this.$set(
                this.data1[index],
                "endDate",
                this.date.dateVal(row.endDate, "YYYY-MM-DD")
              )
            : "";
          key == "indirSupFeedback"
            ? this.$set(
                this.data1[index],
                "indirSupFeedback",
                row.indirSupFeedback
              )
            : "";
          key == "dirSupFeedback"
            ? this.$set(this.data1[index], "dirSupFeedback", row.dirSupFeedback)
            : "";
          key == "empDetails"
            ? this.$set(this.data1[index], "empDetails", row.empDetails)
            : "";
          key == "startDate"
            ? this.$set(
                this.oldData[index],
                "startDate",
                this.date.dateVal(this.oldData[index].startDate, "YYYY-MM-DD")
              )
            : "";
          key == "endDate"
            ? this.$set(
                this.oldData[index],
                "endDate",
                this.date.dateVal(this.oldData[index].endDate, "YYYY-MM-DD")
              )
            : "";
        }
      });
      key == "measure" ? this.$set(this.data1[i], "measure", row.measure) : "";
      key == "finish" ? this.$set(this.data1[i], "finish", row.finish) : "";
      // key=='scheduleFollowUp'?this.$set(this.data1[i],'scheduleFollowUp',row.scheduleFollowUp):''
      if (
        JSON.stringify(this.oldData[i]) != JSON.stringify(this.data1[i]) &&
        !this.targetRevisionState
      ) {
        if (row.status != "新增" && row.status != "删除") {
          /* && row.status!='删除' */
          this.$set(this.data1[i], "status", "编辑");
          this.$set(this.oldData[i], "status", "编辑");
        }
      } else if (!this.targetRevisionState) {
        this.$set(this.data1[i], "status", "");
        this.$set(this.oldData[i], "status", "");
      }
    },
    //单元格合并
    handleSpan({ row, column, rowIndex, columnIndex }) {
      if (this.tabName == "goalSetting") {
        if (this.spanb.length > 0) {
          if (
            columnIndex === 1 ||
            columnIndex === 0 ||
            columnIndex === 2 ||
            columnIndex === 3 ||
            columnIndex === 4 ||
            columnIndex === 5
          ) {
            if (this.spanb[rowIndex]) {
              return {
                rowspan: this.spanb[rowIndex],
                colspan: 1
              };
            } else {
              return {
                rowspan: 0,
                colspan: 1
              };
            }
          }
        }
      } else if (this.tabName == "midTermReview") {
        if (this.spanb.length > 0) {
          if (
            columnIndex === 1 ||
            columnIndex === 0 ||
            columnIndex === 2 ||
            columnIndex === 4 ||
            columnIndex === 5 ||
            columnIndex === 6
          ) {
            if (this.spanb[rowIndex]) {
              return {
                rowspan: this.spanb[rowIndex],
                colspan: 1
              };
            } else {
              return {
                rowspan: 0,
                colspan: 1
              };
            }
          }
        }
      } else {
        if (this.spanb.length > 0) {
          if (
            columnIndex === 1 ||
            columnIndex === 0 ||
            columnIndex === 2 ||
            columnIndex === 4 ||
            columnIndex === 5 ||
            columnIndex === 6
          ) {
            if (this.spanb[rowIndex]) {
              return {
                rowspan: this.spanb[rowIndex],
                colspan: 1
              };
            } else {
              return {
                rowspan: 0,
                colspan: 1
              };
            }
          }
        }
      }
    },
    //单元格合并
    handleSpan2({ row, column, rowIndex, columnIndex }) {
      if (this.tabName == "goalSetting") {
        if (this.spanb2.length > 0) {
          if (
            columnIndex === 1 ||
            columnIndex === 0 ||
            columnIndex === 2 ||
            columnIndex === 3 ||
            columnIndex === 4 ||
            columnIndex === 5
          ) {
            if (this.spanb2[rowIndex]) {
              return {
                rowspan: this.spanb2[rowIndex],
                colspan: 1
              };
            } else {
              return {
                rowspan: 0,
                colspan: 1
              };
            }
          }
        }
      } else if (this.tabName == "midTermReview") {
        if (this.spanb2.length > 0) {
          if (
            columnIndex === 1 ||
            columnIndex === 0 ||
            columnIndex === 2 ||
            columnIndex === 4 ||
            columnIndex === 5 ||
            columnIndex === 6
          ) {
            if (this.spanb2[rowIndex]) {
              return {
                rowspan: this.spanb2[rowIndex],
                colspan: 1
              };
            } else {
              return {
                rowspan: 0,
                colspan: 1
              };
            }
          }
        }
      } else {
        if (this.spanb2.length > 0) {
          if (
            columnIndex === 1 ||
            columnIndex === 0 ||
            columnIndex === 2 ||
            columnIndex === 4 ||
            columnIndex === 5 ||
            columnIndex === 6
          ) {
            if (this.spanb2[rowIndex]) {
              return {
                rowspan: this.spanb2[rowIndex],
                colspan: 1
              };
            } else {
              return {
                rowspan: 0,
                colspan: 1
              };
            }
          }
        }
      }
    },
    tableSpan() {
      let contactDotb = 0;
      let spanb = [];
      this.data1.forEach((item, index) => {
        if (index === 0) {
          spanb.push(1);
        } else {
          if (item.commonId == this.data1[index - 1].commonId) {
            spanb[contactDotb] += 1;
            spanb.push(0);
          } else {
            contactDotb = index;
            spanb.push(1);
          }
        }
      });
      this.spanb = spanb;
    },
    tableSpan2() {
      let contactDotb = 0;
      let spanb = [];
      this.data2.forEach((item, index) => {
        if (index === 0) {
          spanb.push(1);
        } else {
          if (item.commonId == this.data2[index - 1].commonId) {
            spanb[contactDotb] += 1;
            spanb.push(0);
          } else {
            contactDotb = index;
            spanb.push(1);
          }
        }
      });
      this.spanb2 = spanb;
    },
    selectPlan() {
      this.modalShow = true;
      let obj = {
        shared: JSON.parse(sessionStorage.getItem("userInfo")).serialnumber,
        targetType: "绩效重点"
      };
      this.columnsLoading = true;
      axios.post("/achTargetShare/selectTargetShareInfo", obj).then(res => {
        this.columnsLoading = false;
        if (res) {
          this.dataModal = res;
        }
      });
    },
    itemClick(item) {
      this.targetIdList = item;
    },
    modalSave() {
      let list = [];
      this.targetIdList.map((item, index) => {
        var obj = {
          targetId: item.targetId
        };
        list.push(obj);
      });
      axios.post("/achTargetShare/selectAchTargetInfo", list).then(res => {
        if (res) {
          let array = res;
          array.forEach((item, index) => {
            if (index === 0) {
              item.commonId = this.kpiIdNum++;
              this.data1.push(item);
              this.oldData.push(item);
            } else {
              if (item.targetId === array[index - 1].targetId) {
                this.$set(item, "deleteState", true);
                this.$set(array[index - 1], "deleteState", true);
                item.commonId = array[index - 1].commonId;
                this.data1.push(item);
                this.oldData.push(item);
              } else {
                item.commonId = this.kpiIdNum++;
                this.data1.push(item);
                this.oldData.push(item);
              }
            }
            // el.commonId=el.targetId
            // this.data1.push(el)
          });
          // this.data1= this.data1.concat(array);
          this.tableSpan();
          this.modalShow = false;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ivu-table-cell-slot {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/MyAchievementsComponents/PersonalGoals.vue